/* eslint-disable no-unused-vars */

/* eslint-disable react/prop-types */

/* eslint-disable react/display-name */
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

const { colors, devices, fontSizes } = theme;

const StyledText = styled(
  forwardRef(
    (
      {
        desktop,
        mobile,
        ignoreSpan,
        inline,
        weight,
        letterSpacing,
        lineHeight,
        color,
        hoverColor,
        centered,
        underline,
        right,
        size,
        topSpace,
        bottomSpace,
        ...props
      },
      ref
    ) => <div ref={ref} {...props} />
  )
)`
  font-family: 'RethinkSans';
  font-size: ${fontSizes.regular}px;
  font-style: normal;
  font-weight: 400;
  color: ${({ color }) => color};

  span {
    color: ${colors.red.primary};
  }

  ${({ ignoreSpan }) =>
    ignoreSpan &&
    css`
      span {
        color: inherit;
      }
    `}

  ${({ inline }) =>
    inline &&
    css`
      display: inline-block;
    `}

  ${({ size }) =>
    size &&
    css`
      font-size: ${size}px;
    `}

  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}

  ${({ letterSpacing }) =>
    typeof letterSpacing !== 'undefined' &&
    css`
      letter-spacing: ${typeof letterSpacing === 'string' ? letterSpacing : `${letterSpacing}px`};
    `}

  ${({ lineHeight }) =>
    lineHeight &&
    css`
      line-height: ${lineHeight}px;
    `}

  ${({ topSpace }) =>
    typeof topSpace !== 'undefined' &&
    css`
      padding-top: ${typeof topSpace === 'string' ? topSpace : `${topSpace}px`};
    `}

  ${({ bottomSpace }) =>
    bottomSpace &&
    css`
      margin-bottom: ${typeof bottomSpace === 'string' ? bottomSpace : `${bottomSpace}px`};
    `}

  ${({ centered }) =>
    centered &&
    css`
      text-align: center;
    `}

  ${({ underline }) =>
    underline &&
    css`
      text-decoration: underline;
    `}

  ${({ right }) =>
    right &&
    css`
      text-align: end;
    `}

  ${({ mobile }) =>
    mobile &&
    css`
      display: none;
    `}

  &:hover {
    ${({ hoverColor }) =>
      hoverColor &&
      css`
        color: ${hoverColor};
      `}
  }

  @media ${devices.tablet} {
    ${({ desktop }) =>
      desktop &&
      css`
        display: none;
      `}

    ${({ mobile }) =>
      mobile &&
      css`
        display: block;
      `}

    ${({ mobile, inline }) =>
      mobile &&
      inline &&
      css`
        display: inline-block;
      `}

    ${({ mobile, size }) =>
      mobile &&
      size &&
      css`
        font-size: ${size}px;
      `}
  }
`;

const Text = ({
  children,
  desktop,
  mobile,
  weight,
  letterSpacing,
  lineHeight,
  color,
  hoverColor,
  centered,
  underline,
  right,
  size,
  required,
  ignoreSpan,
  inline,
  topSpace,
  bottomSpace,
  ...restProps
}) => (
  <StyledText
    desktop={desktop}
    mobile={mobile}
    weight={weight}
    letterSpacing={letterSpacing}
    lineHeight={lineHeight}
    color={color || colors.gray.primary}
    hoverColor={hoverColor}
    centered={centered}
    underline={underline}
    right={right}
    size={size}
    ignoreSpan={ignoreSpan}
    inline={inline}
    topSpace={topSpace}
    bottomSpace={bottomSpace}
    {...restProps}
  >
    {children}
    {required && <span>&nbsp;*</span>}
  </StyledText>
);

Text.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  desktop: PropTypes.bool,
  mobile: PropTypes.bool,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  centered: PropTypes.bool,
  underline: PropTypes.bool,
  right: PropTypes.bool,
  size: PropTypes.number,
  weight: PropTypes.number,
  letterSpacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lineHeight: PropTypes.number,
  required: PropTypes.bool,
  ignoreSpan: PropTypes.bool,
  inline: PropTypes.bool,
  topSpace: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bottomSpace: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Text;
